import { configureStore } from "@reduxjs/toolkit";
import companyReducer from "./company/companySlice";
import userReducer from "./user/userSlice";
import switchAccountSlice from "./user/switchAccountSlice";
import balanceReducer from "./user/balanceSlice";
import configReducer from "./config/configSlice";
import tokenReducer from "./token/tokenSlice";
import languageSlice from "./language/languageSlice";
import customAppSlice from "./company/customAppsSlice";
import lastServiceSlice from "./lastService/lastServiceSlice";
import iconAppSlice from "./company/iconAppSlice";
import menuOrderReducer from "./menuOrder/menuOrderSlice";

// export default configureStore({
//   reducer: {
//     company: companyReducer,
//   },
// });
const initStore = (preloadedState = {}) => {
  return configureStore({
    reducer: companyReducer,
    preloadedState,
  });
};

export const store = configureStore({
  reducer: {
    company: companyReducer,
    user: userReducer,
    switchAccounts: switchAccountSlice,
    balance: balanceReducer,
    config: configReducer,
    token: tokenReducer,
    language: languageSlice,
    lastService: lastServiceSlice,
    customApp: customAppSlice,
    iconApp: iconAppSlice,
    menuOrder: menuOrderReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export default store;
